import {DatePipe} from '@angular/common';
import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Sort} from '@angular/material/sort';
import {Router} from '@angular/router';
import * as _ from 'lodash';
import {Subscription} from 'rxjs';
import {PageParams} from '../../../core/models/page-params.model';
import {ConstantService} from '../../../core/services/constant.service';
import {MarketplacesService} from '../../../core/services/marketplaces.service';
import {NotificationService} from '../../../core/services/notification.service';
import {UploadFileService} from '../../../core/services/upload-file.service';
import {UserService} from '../../../core/services/user.service';
import {HideShowFieldsComponent} from '../../../shared/popups/hideshow-fields/hideshowfields.component';
import {RegistrationService} from '../../customer-registration/services/registration.service';
import {FieldList} from '../components/hideshow-fields-param';

import {ISaleOrder} from '../models/sale-order.interface';
import {SaleOrderService} from '../services/sale-order.service';
import { TableSalesOrderUploadHistoryComponent } from '../components/invat-order-table-upload-history/ind-vat-table-sales-order-upload-history.component';


const Field_List: FieldList[] = [
];

@Component({
  selector: 'eci-invat-order-upload-history-page',
  templateUrl: './invat-order-upload-history-page.component.html',
  styleUrls: ['./invat-order-upload-history-page.component.scss']
})

export class InvatOrderUploadHistoryPageComponent implements OnInit, OnDestroy {

    pageParams: PageParams = new PageParams();
    fromData: FormControl = new FormControl('');
    toData: FormControl = new FormControl('');
    searchStr = new FormControl('');
    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    currentSort: Sort;
    sumOfTotalFIelds: any = [];
    sumOfTotalFIeldsIncludingCancelled: any = [];
    previousUrl: string = null;
    currentUrl: string = null;
    showLoader: boolean = false;

    listOfSelectedItems: number[] = [];
    listOfSelectedItemsBody: ISaleOrder[] = [];

    previousePageCustomer: number = 0;
    totalPagesCustomers: number = 0;

    companyList: any[];
    previus_search:any;
    routeSubscription: Subscription;

    uploadSubscription;

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ?
            this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value) :
            this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value);
    }

    constructor(
        private router: Router,
        public userSvc: UserService,
        private dialog: MatDialog,
        private saleOrderSvc: SaleOrderService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        private notify: NotificationService,
        private marketplaceSvc: MarketplacesService,
        private regSvc: RegistrationService,
        private uploadFileSvc: UploadFileService
    ) { }

    displayedColumns: string[] = [
        'createdAt',
        'uploadMethodName',
        'fileName',
        'filePath'
    ];
    dataSource;

    ngOnInit(): void {
        this.getList(1, 10, '','','');
        //this.downloadFile(1);
    }


    async getList(
        page: number = this.pageParams?.pageIndex + 1,
        limit: number = this.pageParams?.pageSize,
        q: string = this.searchStr.value,
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || ''
    ): Promise<void> {
        this.showLoader = true;
        await this.saleOrderSvc.getSalesOrderUploadHistory(
            page,
            limit,
            q,
            this.prepareSearchParams,
            orderField,
            orderDir
        ).subscribe(data => {
            this.showLoader = false;
            if (!data) return;
            this.dataSource = data.items;
            this.pageParams.pageSize = data.meta.itemsPerPage;
            this.pageParams.pageIndex = data.meta.currentPage - 1;
            this.pageParams.length = data.meta.totalItems;
        });

    }

    get prepareSearchParams(): any {
        return {

            dateTo: this.toData.value && this.toData.value !== null ? this.datePipe.transform(this.toData.value, 'yyyy-MM-dd') : '',
            dateFrom: this.toData.value && this.fromData.value !== null ? this.datePipe.transform(this.fromData.value, 'yyyy-MM-dd') : '',

        }
    }

    downloadFile(el: {file: any }){
        window.open(`${el.file}`, '_blank');
    }

    documentSave(event:any){
    }

    sortData(sort: Sort): void {
        this.currentSort = sort;
        this.getList(
            this.pageParams?.pageIndex + 1,
            this.pageParams?.pageSize,
            this.searchStr.value || '',
        );
    }

    search(): void {
        this.getList(1, 100, this.searchStr.value);
    }


    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.customerName.value ? this.customerName.value : q;
        this.regSvc.getCompanyListForSales(q, true).subscribe(data => {
            if (!data) return;
            this.companyList = data;
        })
    }

    clearSelection() {
        this.customerName.reset();
        this.getListCompanies(this.searchCustomerName.value);
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
    }

    openHideShowFieldsPopup(): void {
        const dialogRef = this.dialog.open(HideShowFieldsComponent, {
            width: '500px',
            data: {fields: Field_List, settingName: 'INDVAT_SALES_ORDER_VISIBLITY_FIELD_RULE'}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.dataSource.data = result;
            this.getList();
        });
    }

    ngOnDestroy(): void {

    }

}
